import ApplicationController from './application_controller'

export default class extends ApplicationController {
  scrollToBottom() {
    const chatContainer = document.querySelector('.flex-grow.overflow-y-auto.space-y-4')
    if (chatContainer) {
      chatContainer.scrollTo({
        top: chatContainer.scrollHeight,
        behavior: 'smooth',
      })
    }
  }

  reload() {
    location.reload()
  }

  scrollToMessage(event) {
    const messageId = event.currentTarget.dataset.messageId
    const messageElement = document.querySelector(`[data-message-id="${messageId}"]`)
    if (messageElement) {
      messageElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      // Highlight the message briefly
      messageElement.classList.add('ring-2', 'ring-blue-400', 'ring-offset-2')
      setTimeout(() => {
        messageElement.classList.remove('ring-2', 'ring-blue-400', 'ring-offset-2')
      }, 2000)
    }
  }
}
